import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();
    
    const subsidiaryId = this.authService.getCurrentSubsidiaryId();
    
    if (token) {
      let headers = request.headers.set('Authorization', `Bearer ${token}`);
      
      if (subsidiaryId) {
        headers = headers.set('X-Subsidiary-ID', subsidiaryId.toString());
      }
      
      request = request.clone({
        headers
      });
    }
    
    return next.handle(request);
  }
}